import { Button, Flex, ModalV2, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";
import { UserData } from "./hooks";
import { userNames } from "./style_vanilla.css";

export const UsersWithoutRolesModal = ({
  usersWithoutRoles,
  showModal,
  onHide,
}: {
  usersWithoutRoles: UserData[];
  showModal: boolean;
  onHide: () => void;
}) => {
  return (
    <ModalV2 isCentered show={showModal} onHide={onHide} size="small" title="">
      <ModalV2.Body>
        <Flex flexDirection="column" alignItems="center" gap={SPACING.MEDIUM}>
          <Icon type="exclamation-circle" size={"xx-large"} color={Colors.Danger500} />
          <Text variant="h2">Canopy access warning</Text>
          <Text variant="regular-md">
            The following users now have no Canopy roles and have lost access to Canopy.
          </Text>
          <Flex
            className={userNames}
            flexDirection="column"
            alignItems="flex-start"
            gap={SPACING.SMALL}
          >
            {usersWithoutRoles.map((user) => (
              <Flex key={user.fullName} flexDirection="column">
                <Text variant="strong-md">{user.fullName}</Text>
                <Text variant="regular-sm">{user.emailAddress}</Text>
              </Flex>
            ))}
          </Flex>
        </Flex>
      </ModalV2.Body>
      <ModalV2.Footer>
        <Button variant="neutral" onClick={onHide} isFullWidth>
          Close
        </Button>
      </ModalV2.Footer>
    </ModalV2>
  );
};
